var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024px",
    height: "880px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M -0.5,-0.5 C 149.5,-0.5 299.5,-0.5 449.5,-0.5C 449.049,9.82867 448.716,20.162 448.5,30.5C 440.16,30.3336 431.827,30.5003 423.5,31C 423,31.5 422.5,32 422,32.5C 421.333,53.5 421.333,74.5 422,95.5C 422.5,96 423,96.5 423.5,97C 432.01,97.1706 440.343,97.6706 448.5,98.5C 448.824,112.745 448.49,126.912 447.5,141C 397.659,139.77 347.825,138.27 298,136.5C 296.566,136.862 295.399,137.528 294.5,138.5C 293.542,138.047 292.708,137.381 292,136.5C 291.814,139.036 291.314,141.369 290.5,143.5C 289.833,141.167 289.167,138.833 288.5,136.5C 240.342,134.795 192.342,133.129 144.5,131.5C 135.682,130.507 126.682,130.173 117.5,130.5C 117.818,147.244 117.485,163.911 116.5,180.5C 115.833,180.5 115.167,180.5 114.5,180.5C 112.393,179.532 110.059,179.198 107.5,179.5C 107.819,167.428 107.486,155.428 106.5,143.5C 107.486,139.03 107.819,134.363 107.5,129.5C 94.8333,129.5 82.1667,129.5 69.5,129.5C 46.1407,129.536 22.8073,128.87 -0.5,127.5C -0.5,84.8333 -0.5,42.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 802.5,6.5 C 818.453,8.02218 834.453,8.68885 850.5,8.5C 852.653,7.42708 854.653,7.42708 856.5,8.5C 876.311,10.1898 896.311,11.1898 916.5,11.5C 948.335,13.0868 980.335,14.4201 1012.5,15.5C 1016.17,15.5 1019.83,15.5 1023.5,15.5C 1023.5,60.1667 1023.5,104.833 1023.5,149.5C 1011.75,139.082 1000.42,128.415 989.5,117.5C 975.415,130.753 961.748,144.586 948.5,159C 961.613,173.446 975.446,187.279 990,200.5C 1001.47,189.84 1012.64,178.84 1023.5,167.5C 1023.5,186.833 1023.5,206.167 1023.5,225.5C 1013.83,225.211 1004.16,224.878 994.5,224.5C 978.696,222.87 962.696,222.204 946.5,222.5C 931.023,221.045 915.356,220.378 899.5,220.5C 895.167,220.5 890.833,220.5 886.5,220.5C 869.349,219.174 852.016,218.507 834.5,218.5C 827.412,218.795 820.412,218.462 813.5,217.5C 808.99,217.116 804.657,216.449 800.5,215.5C 801.33,206.676 801.83,197.676 802,188.5C 802.253,134.663 802.753,80.8301 803.5,27C 803.463,20.1203 803.13,13.287 802.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767577",
    d: "M 802.5,6.5 C 803.097,5.86137 803.93,5.52804 805,5.5C 820.304,6.71062 835.471,7.71062 850.5,8.5C 834.453,8.68885 818.453,8.02218 802.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787679",
    d: "M 856.5,8.5 C 877.02,8.84199 897.354,9.84199 917.5,11.5C 917.167,11.5 916.833,11.5 916.5,11.5C 896.311,11.1898 876.311,10.1898 856.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#626062",
    d: "M 916.5,11.5 C 916.833,11.5 917.167,11.5 917.5,11.5C 949.37,11.7409 981.036,13.0742 1012.5,15.5C 980.335,14.4201 948.335,13.0868 916.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#c1bcb2",
    d: "M 448.5,30.5 C 462.833,30.5 477.167,30.5 491.5,30.5C 492.509,53.5969 492.509,76.5969 491.5,99.5C 477.088,99.8156 462.755,99.4822 448.5,98.5C 440.343,97.6706 432.01,97.1706 423.5,97C 423,96.5 422.5,96 422,95.5C 421.333,74.5 421.333,53.5 422,32.5C 422.5,32 423,31.5 423.5,31C 431.827,30.5003 440.16,30.3336 448.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4d4f",
    d: "M 802.5,6.5 C 803.13,13.287 803.463,20.1203 803.5,27C 802.753,80.8301 802.253,134.663 802,188.5C 801.83,197.676 801.33,206.676 800.5,215.5C 801.065,145.364 801.732,75.6978 802.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee772e",
    d: "M 684.5,68.5 C 683.833,68.5 683.5,68.8333 683.5,69.5C 681.771,68.8825 680.271,67.8825 679,66.5C 678.261,67.5742 677.261,68.2409 676,68.5C 671.08,67.024 666.08,66.024 661,65.5C 659.853,66.4581 658.853,66.1247 658,64.5C 655.289,65.9256 652.789,65.5923 650.5,63.5C 641.509,63.7793 632.509,63.1126 623.5,61.5C 623.5,60.8333 623.167,60.5 622.5,60.5C 622.5,59.5 622.5,58.5 622.5,57.5C 643.33,57.5937 663.997,57.927 684.5,58.5C 684.5,61.8333 684.5,65.1667 684.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#df8530",
    d: "M 623.5,61.5 C 632.509,63.1126 641.509,63.7793 650.5,63.5C 652.789,65.5923 655.289,65.9256 658,64.5C 658.853,66.1247 659.853,66.4581 661,65.5C 666.08,66.024 671.08,67.024 676,68.5C 677.261,68.2409 678.261,67.5742 679,66.5C 680.271,67.8825 681.771,68.8825 683.5,69.5C 663.674,70.4971 643.674,70.8305 623.5,70.5C 623.5,67.5 623.5,64.5 623.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c87d37",
    d: "M 622.5,60.5 C 623.167,60.5 623.5,60.8333 623.5,61.5C 623.5,64.5 623.5,67.5 623.5,70.5C 643.674,70.8305 663.674,70.4971 683.5,69.5C 683.5,68.8333 683.833,68.5 684.5,68.5C 684.5,70.5 684.5,72.5 684.5,74.5C 684.167,74.5 683.833,74.5 683.5,74.5C 663.674,73.5029 643.674,73.1695 623.5,73.5C 623.167,73.5 622.833,73.5 622.5,73.5C 622.5,71.8333 622.5,70.1667 622.5,68.5C 622.5,66.5 622.5,64.5 622.5,62.5C 622.5,61.8333 622.5,61.1667 622.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M 623.5,73.5 C 643.674,73.1695 663.674,73.5029 683.5,74.5C 683.5,85.1667 683.5,95.8333 683.5,106.5C 663.5,106.5 643.5,106.5 623.5,106.5C 623.5,95.5 623.5,84.5 623.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b999d",
    d: "M 622.5,62.5 C 622.5,64.5 622.5,66.5 622.5,68.5C 615.783,67.6939 609.116,66.8606 602.5,66C 582.788,83.2417 562.454,99.4084 541.5,114.5C 542.85,113.35 542.684,112.683 541,112.5C 539.862,112.989 538.695,113.322 537.5,113.5C 560.688,95.3066 583.855,76.9732 607,58.5C 607.651,60.235 607.485,61.9017 606.5,63.5C 612.098,65.0331 617.431,64.6997 622.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec8744",
    d: "M 622.5,73.5 C 622.833,73.5 623.167,73.5 623.5,73.5C 623.5,84.5 623.5,95.5 623.5,106.5C 643.5,106.5 663.5,106.5 683.5,106.5C 683.5,95.8333 683.5,85.1667 683.5,74.5C 683.833,74.5 684.167,74.5 684.5,74.5C 684.19,85.2186 684.523,95.8853 685.5,106.5C 664.307,107.917 643.307,108.251 622.5,107.5C 622.5,96.1667 622.5,84.8333 622.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed6d1d",
    d: "M 1023.5,149.5 C 1023.5,155.5 1023.5,161.5 1023.5,167.5C 1012.64,178.84 1001.47,189.84 990,200.5C 975.446,187.279 961.613,173.446 948.5,159C 961.748,144.586 975.415,130.753 989.5,117.5C 1000.42,128.415 1011.75,139.082 1023.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e79464",
    d: "M 69.5,129.5 C 82.1667,129.5 94.8333,129.5 107.5,129.5C 107.819,134.363 107.486,139.03 106.5,143.5C 106.5,139.167 106.5,134.833 106.5,130.5C 93.9887,130.829 81.6554,130.495 69.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e49263",
    d: "M 144.5,131.5 C 135.833,131.5 127.167,131.5 118.5,131.5C 117.871,148.073 118.538,164.406 120.5,180.5C 119.167,180.5 117.833,180.5 116.5,180.5C 117.485,163.911 117.818,147.244 117.5,130.5C 126.682,130.173 135.682,130.507 144.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e59464",
    d: "M 288.5,136.5 C 289.167,138.833 289.833,141.167 290.5,143.5C 290.5,144.167 290.167,144.5 289.5,144.5C 288.527,142.052 288.194,139.385 288.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8784",
    d: "M 294.5,138.5 C 293.679,146.105 293.012,153.772 292.5,161.5C 291.5,161.5 290.5,161.5 289.5,161.5C 289.5,155.833 289.5,150.167 289.5,144.5C 290.167,144.5 290.5,144.167 290.5,143.5C 291.314,141.369 291.814,139.036 292,136.5C 292.708,137.381 293.542,138.047 294.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec9d55",
    d: "M 289.5,161.5 C 290.5,161.5 291.5,161.5 292.5,161.5C 295.022,163.172 297.688,164.672 300.5,166C 302.641,172.784 303.641,179.784 303.5,187C 303.498,190.352 303.165,193.518 302.5,196.5C 302.919,186.705 302.086,177.039 300,167.5C 299.667,167.833 299.333,168.167 299,168.5C 297.484,165.949 296.651,166.282 296.5,169.5C 293.99,169.002 291.49,168.336 289,167.5C 287.213,167.759 285.713,168.425 284.5,169.5C 284.667,165.821 286.334,163.154 289.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee8e30",
    d: "M 302.5,196.5 C 302.405,201.711 300.071,205.378 295.5,207.5C 292.946,208.388 290.279,208.721 287.5,208.5C 285.62,206.074 284.287,203.408 283.5,200.5C 282.602,192.876 282.269,185.209 282.5,177.5C 282.111,174.447 282.777,171.78 284.5,169.5C 285.713,168.425 287.213,167.759 289,167.5C 291.49,168.336 293.99,169.002 296.5,169.5C 296.651,166.282 297.484,165.949 299,168.5C 299.333,168.167 299.667,167.833 300,167.5C 302.086,177.039 302.919,186.705 302.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898689",
    d: "M 541.5,114.5 C 527.733,126.926 513.066,138.259 497.5,148.5C 480.722,162.953 463.389,176.619 445.5,189.5C 445.5,188.167 444.833,187.5 443.5,187.5C 446.043,184.22 449.043,181.387 452.5,179C 480.502,156.674 508.836,134.84 537.5,113.5C 538.695,113.322 539.862,112.989 541,112.5C 542.684,112.683 542.85,113.35 541.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#695e5b",
    d: "M 107.5,179.5 C 110.059,179.198 112.393,179.532 114.5,180.5C 106.809,180.403 99.1421,180.737 91.5,181.5C 96.5683,179.822 101.902,179.156 107.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 114.5,180.5 C 115.167,180.5 115.833,180.5 116.5,180.5C 117.833,180.5 119.167,180.5 120.5,180.5C 121.167,180.5 121.833,180.5 122.5,180.5C 125.145,182.31 128.145,183.31 131.5,183.5C 132.791,183.263 133.791,183.596 134.5,184.5C 136.03,186.346 138.03,187.346 140.5,187.5C 143.704,188.383 146.371,190.05 148.5,192.5C 149.539,194.531 151.205,195.864 153.5,196.5C 153.81,198.144 154.81,199.144 156.5,199.5C 157.08,201.749 158.413,203.415 160.5,204.5C 160.833,205.5 161.5,206.167 162.5,206.5C 163.338,206.842 163.672,207.508 163.5,208.5C 163.738,210.404 164.738,211.738 166.5,212.5C 166.5,212.833 166.5,213.167 166.5,213.5C 166.427,215.027 167.094,216.027 168.5,216.5C 168.427,218.027 169.094,219.027 170.5,219.5C 171.736,221.649 172.736,223.982 173.5,226.5C 174.073,232.455 175.407,238.122 177.5,243.5C 177.5,243.833 177.5,244.167 177.5,244.5C 177.5,247.167 177.5,249.833 177.5,252.5C 166.833,252.5 156.167,252.5 145.5,252.5C 110.673,251.253 75.6731,250.586 40.5,250.5C 39.7682,247.932 39.7682,245.266 40.5,242.5C 41.9034,239.091 42.5701,235.425 42.5,231.5C 44.0159,224.601 46.6826,218.268 50.5,212.5C 51.9063,212.027 52.573,211.027 52.5,209.5C 53.9063,209.027 54.573,208.027 54.5,206.5C 54.5,205.167 55.1667,204.5 56.5,204.5C 58.914,203.089 60.5806,201.089 61.5,198.5C 69.7741,189.847 79.7741,184.181 91.5,181.5C 99.1421,180.737 106.809,180.403 114.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b898d",
    d: "M 122.5,180.5 C 125.855,180.69 128.855,181.69 131.5,183.5C 128.145,183.31 125.145,182.31 122.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7b80",
    d: "M 134.5,184.5 C 136.97,184.654 138.97,185.654 140.5,187.5C 138.03,187.346 136.03,186.346 134.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0ad7e",
    d: "M 282.5,177.5 C 282.269,185.209 282.602,192.876 283.5,200.5C 282.778,200.082 282.278,199.416 282,198.5C 281.179,191.321 281.345,184.321 282.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aca9ac",
    d: "M 439.5,190.5 C 439.389,191.117 439.056,191.617 438.5,192C 441.365,192.183 444.031,192.683 446.5,193.5C 441.988,193.851 437.655,193.185 433.5,191.5C 435.396,190.534 437.396,190.201 439.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b0b4",
    d: "M 502.5,195.5 C 499.635,195.945 497.135,195.278 495,193.5C 493.644,194.38 492.144,194.714 490.5,194.5C 492.189,193.696 493.855,192.696 495.5,191.5C 496.287,192.242 496.953,193.075 497.5,194C 499.382,194.198 501.048,194.698 502.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757377",
    d: "M 148.5,192.5 C 150.754,193.124 152.421,194.457 153.5,196.5C 151.205,195.864 149.539,194.531 148.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737273",
    d: "M 443.5,187.5 C 444.833,187.5 445.5,188.167 445.5,189.5C 460.396,191.29 475.396,192.956 490.5,194.5C 492.144,194.714 493.644,194.38 495,193.5C 497.135,195.278 499.635,195.945 502.5,195.5C 512.171,196.111 521.838,196.778 531.5,197.5C 533.969,198.317 536.635,198.817 539.5,199C 535.179,199.499 530.846,199.666 526.5,199.5C 499.844,197.39 473.177,195.39 446.5,193.5C 444.031,192.683 441.365,192.183 438.5,192C 439.056,191.617 439.389,191.117 439.5,190.5C 440.436,189.026 441.77,188.026 443.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6c70",
    d: "M 153.5,196.5 C 155.19,196.856 156.19,197.856 156.5,199.5C 154.81,199.144 153.81,198.144 153.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979599",
    d: "M 531.5,197.5 C 542.003,197.899 552.336,198.565 562.5,199.5C 557.489,199.334 552.489,199.501 547.5,200C 549.382,200.198 551.048,200.698 552.5,201.5C 543.657,201.179 534.991,200.512 526.5,199.5C 530.846,199.666 535.179,199.499 539.5,199C 536.635,198.817 533.969,198.317 531.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969497",
    d: "M 565.5,200.5 C 565.5,200.167 565.5,199.833 565.5,199.5C 575.713,199.228 585.713,199.895 595.5,201.5C 585.509,200.945 575.509,200.612 565.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757374",
    d: "M 156.5,199.5 C 158.587,200.585 159.92,202.251 160.5,204.5C 158.413,203.415 157.08,201.749 156.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585757",
    d: "M 562.5,199.5 C 563.5,199.5 564.5,199.5 565.5,199.5C 565.5,199.833 565.5,200.167 565.5,200.5C 564.448,200.351 563.448,200.517 562.5,201C 565.365,201.183 568.031,201.683 570.5,202.5C 564.5,202.167 558.5,201.833 552.5,201.5C 551.048,200.698 549.382,200.198 547.5,200C 552.489,199.501 557.489,199.334 562.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353433",
    d: "M 565.5,200.5 C 575.509,200.612 585.509,200.945 595.5,201.5C 597.292,202.309 599.292,202.809 601.5,203C 591.176,202.982 580.843,202.816 570.5,202.5C 568.031,201.683 565.365,201.183 562.5,201C 563.448,200.517 564.448,200.351 565.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b787b",
    d: "M 61.5,198.5 C 60.5806,201.089 58.914,203.089 56.5,204.5C 57.4194,201.911 59.086,199.911 61.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878485",
    d: "M 595.5,201.5 C 603.007,201.864 610.341,202.53 617.5,203.5C 613.154,203.334 608.821,203.501 604.5,204C 606.382,204.198 608.048,204.698 609.5,205.5C 596.328,204.827 583.328,203.827 570.5,202.5C 580.843,202.816 591.176,202.982 601.5,203C 599.292,202.809 597.292,202.309 595.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b979b",
    d: "M 160.5,204.5 C 161.833,204.5 162.5,205.167 162.5,206.5C 161.5,206.167 160.833,205.5 160.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686566",
    d: "M 617.5,203.5 C 648.306,205.681 678.973,207.681 709.5,209.5C 718.012,210.146 726.345,211.146 734.5,212.5C 732.473,212.338 730.473,212.505 728.5,213C 730.382,213.198 732.048,213.698 733.5,214.5C 692.202,210.99 650.869,207.99 609.5,205.5C 608.048,204.698 606.382,204.198 604.5,204C 608.821,203.501 613.154,203.334 617.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828284",
    d: "M 54.5,206.5 C 54.573,208.027 53.9063,209.027 52.5,209.5C 52.427,207.973 53.0937,206.973 54.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#161412",
    d: "M 709.5,209.5 C 711.969,210.317 714.635,210.817 717.5,211C 708.495,211.2 699.495,210.867 690.5,210C 696.825,209.5 703.158,209.334 709.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7b80",
    d: "M 163.5,208.5 C 165.262,209.262 166.262,210.596 166.5,212.5C 164.738,211.738 163.738,210.404 163.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838284",
    d: "M 52.5,209.5 C 52.573,211.027 51.9063,212.027 50.5,212.5C 50.427,210.973 51.0937,209.973 52.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#837c80",
    d: "M 295.5,207.5 C 294.593,213.106 294.26,218.773 294.5,224.5C 294.167,224.5 293.833,224.5 293.5,224.5C 293.5,219.5 293.5,214.5 293.5,209.5C 291.833,209.5 290.167,209.5 288.5,209.5C 288.54,212.881 288.207,216.214 287.5,219.5C 287.06,216.038 287.06,212.371 287.5,208.5C 290.279,208.721 292.946,208.388 295.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3a38",
    d: "M 734.5,212.5 C 736.5,212.5 738.5,212.5 740.5,212.5C 742.292,213.309 744.292,213.809 746.5,214C 744.19,214.497 741.857,214.663 739.5,214.5C 737.5,214.5 735.5,214.5 733.5,214.5C 732.048,213.698 730.382,213.198 728.5,213C 730.473,212.505 732.473,212.338 734.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#706e6f",
    d: "M 740.5,212.5 C 760.596,213.861 780.596,214.861 800.5,215.5C 804.657,216.449 808.99,217.116 813.5,217.5C 812.903,218.139 812.07,218.472 811,218.5C 787.005,217.409 763.172,216.076 739.5,214.5C 741.857,214.663 744.19,214.497 746.5,214C 744.292,213.809 742.292,213.309 740.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757276",
    d: "M 166.5,213.5 C 167.906,213.973 168.573,214.973 168.5,216.5C 167.094,216.027 166.427,215.027 166.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a4252",
    d: "M 293.5,224.5 C 291.053,224.385 289.053,223.385 287.5,221.5C 287.5,220.833 287.5,220.167 287.5,219.5C 288.207,216.214 288.54,212.881 288.5,209.5C 290.167,209.5 291.833,209.5 293.5,209.5C 293.5,214.5 293.5,219.5 293.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a898e",
    d: "M 168.5,216.5 C 169.906,216.973 170.573,217.973 170.5,219.5C 169.094,219.027 168.427,218.027 168.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838183",
    d: "M 834.5,218.5 C 852.016,218.507 869.349,219.174 886.5,220.5C 868.982,220.543 851.649,219.876 834.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656366",
    d: "M 899.5,220.5 C 915.356,220.378 931.023,221.045 946.5,222.5C 930.652,222.413 914.986,221.747 899.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7b7f",
    d: "M 946.5,222.5 C 962.696,222.204 978.696,222.87 994.5,224.5C 978.326,224.229 962.326,223.562 946.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c7ce",
    d: "M 287.5,221.5 C 289.053,223.385 291.053,224.385 293.5,224.5C 293.833,224.5 294.167,224.5 294.5,224.5C 294.586,225.496 294.252,226.329 293.5,227C 291.527,227.495 289.527,227.662 287.5,227.5C 287.5,225.5 287.5,223.5 287.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777478",
    d: "M 173.5,226.5 C 175.593,231.878 176.927,237.545 177.5,243.5C 175.407,238.122 174.073,232.455 173.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666467",
    d: "M 42.5,231.5 C 42.5701,235.425 41.9034,239.091 40.5,242.5C 40.4299,238.575 41.0966,234.909 42.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b797c",
    d: "M 40.5,242.5 C 39.7682,245.266 39.7682,247.932 40.5,250.5C 39.3509,250.209 38.6842,249.376 38.5,248C 38.7006,245.889 39.3673,244.055 40.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6b6d",
    d: "M 40.5,250.5 C 75.6731,250.586 110.673,251.253 145.5,252.5C 143.833,252.5 142.167,252.5 140.5,252.5C 106.989,252.618 73.6561,251.952 40.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#918e91",
    d: "M 177.5,244.5 C 178.477,247.287 178.81,250.287 178.5,253.5C 165.656,253.829 152.989,253.495 140.5,252.5C 142.167,252.5 143.833,252.5 145.5,252.5C 156.167,252.5 166.833,252.5 177.5,252.5C 177.5,249.833 177.5,247.167 177.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a3a5",
    d: "M 72.5,336.5 C 71.5,336.5 70.5,336.5 69.5,336.5C 69.8237,321.921 69.4904,307.421 68.5,293C 45.5016,290.367 22.5016,287.867 -0.5,285.5C -0.5,284.5 -0.5,283.5 -0.5,282.5C 22.7945,285.134 45.7945,287.134 68.5,288.5C 69.2811,287.271 69.7811,285.938 70,284.5C 70.4995,278.509 70.6662,272.509 70.5,266.5C 71.5,266.5 72.5,266.5 73.5,266.5C 73.4444,274.445 73.4444,282.112 73.5,289.5C 74.1667,289.167 74.8333,288.833 75.5,288.5C 113.852,294.963 152.519,300.296 191.5,304.5C 191.5,305.833 191.5,307.167 191.5,308.5C 151.998,302.271 112.331,297.271 72.5,293.5C 72.7075,307.743 72.7075,322.077 72.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#010201",
    d: "M 714.5,314.5 C 728.091,313.812 740.424,317.312 751.5,325C 753.888,327.05 755.888,329.384 757.5,332C 752.366,337.464 746.866,342.631 741,347.5C 730.873,336.01 719.039,333.843 705.5,341C 693.11,353.738 692.443,367.071 703.5,381C 717.342,389.486 730.009,387.986 741.5,376.5C 746.761,381.05 751.928,385.716 757,390.5C 756.973,392.417 756.139,394.084 754.5,395.5C 741.576,406.651 726.576,410.818 709.5,408C 680.069,401.216 666.902,382.716 670,352.5C 676.145,329.513 690.978,316.847 714.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#010201",
    d: "M 250.5,316.5 C 267.17,316.333 283.837,316.5 300.5,317C 324.089,320.353 334.589,333.853 332,357.5C 327.536,372.669 317.369,381.169 301.5,383C 293.507,383.5 285.507,383.666 277.5,383.5C 277.5,391.167 277.5,398.833 277.5,406.5C 268.5,406.5 259.5,406.5 250.5,406.5C 250.5,376.5 250.5,346.5 250.5,316.5 Z M 277.5,337.5 C 284.906,337.152 292.239,337.652 299.5,339C 303.851,341.365 306.184,345.032 306.5,350C 306.184,354.968 303.851,358.635 299.5,361C 292.254,362.391 284.921,362.891 277.5,362.5C 277.5,354.167 277.5,345.833 277.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#010201",
    d: "M 343.5,316.5 C 360.17,316.333 376.837,316.5 393.5,317C 420.027,321.867 429.86,337.367 423,363.5C 419.888,370.279 415.055,375.445 408.5,379C 414.833,388 421.167,397 427.5,406C 417.816,406.832 408.149,406.665 398.5,405.5C 393.623,398.246 388.623,391.079 383.5,384C 379.179,383.501 374.846,383.334 370.5,383.5C 370.5,391.167 370.5,398.833 370.5,406.5C 361.5,406.5 352.5,406.5 343.5,406.5C 343.5,376.5 343.5,346.5 343.5,316.5 Z M 370.5,337.5 C 377.906,337.152 385.239,337.652 392.5,339C 397.105,341.208 399.105,344.875 398.5,350C 399.105,355.125 397.105,358.792 392.5,361C 385.254,362.391 377.921,362.891 370.5,362.5C 370.5,354.167 370.5,345.833 370.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#010201",
    d: "M 438.5,316.5 C 447.167,316.5 455.833,316.5 464.5,316.5C 464.5,346.5 464.5,376.5 464.5,406.5C 455.833,406.5 447.167,406.5 438.5,406.5C 438.5,376.5 438.5,346.5 438.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#010201",
    d: "M 471.5,316.5 C 480.857,316.168 490.19,316.502 499.5,317.5C 507.057,336.282 514.891,354.948 523,373.5C 531,354.833 539,336.167 547,317.5C 555.755,316.35 564.588,316.184 573.5,317C 560.74,346.442 548.073,375.942 535.5,405.5C 526.5,406.833 517.5,406.833 508.5,405.5C 495.872,375.916 483.538,346.249 471.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#010201",
    d: "M 603.5,316.5 C 612.192,316.169 620.859,316.502 629.5,317.5C 642.5,346.833 655.5,376.167 668.5,405.5C 659.518,406.665 650.518,406.832 641.5,406C 639.361,400.584 637.028,395.251 634.5,390C 622.167,389.333 609.833,389.333 597.5,390C 595.361,395.416 593.028,400.749 590.5,406C 581.5,406.667 572.5,406.667 563.5,406C 576.977,376.215 590.31,346.382 603.5,316.5 Z M 615.5,343.5 C 619.391,351.626 623.058,359.959 626.5,368.5C 619.524,369.664 612.524,369.831 605.5,369C 609.129,360.612 612.463,352.112 615.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#010201",
    d: "M 756.5,316.5 C 765.857,316.168 775.19,316.502 784.5,317.5C 791.082,328.999 797.915,340.333 805,351.5C 811.707,339.917 818.541,328.417 825.5,317C 833.853,316.168 842.187,316.335 850.5,317.5C 839.585,336.332 828.418,354.999 817,373.5C 816.5,384.495 816.333,395.495 816.5,406.5C 807.833,406.5 799.167,406.5 790.5,406.5C 790.667,395.495 790.5,384.495 790,373.5C 778.306,354.774 767.139,335.774 756.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M 69.5,337.5 C 69.8333,337.5 70.1667,337.5 70.5,337.5C 71.1119,351.828 71.1119,366.162 70.5,380.5C 70.1667,380.5 69.8333,380.5 69.5,380.5C 61.1667,380.5 52.8333,380.5 44.5,380.5C 44.5,366.167 44.5,351.833 44.5,337.5C 52.8333,337.5 61.1667,337.5 69.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea8644",
    d: "M 69.5,336.5 C 69.5,336.833 69.5,337.167 69.5,337.5C 61.1667,337.5 52.8333,337.5 44.5,337.5C 44.5,351.833 44.5,366.167 44.5,380.5C 52.8333,380.5 61.1667,380.5 69.5,380.5C 69.5,380.833 69.5,381.167 69.5,381.5C 69.1667,381.5 68.8333,381.5 68.5,381.5C 68.1667,381.5 67.8333,381.5 67.5,381.5C 59.5,381.5 51.5,381.5 43.5,381.5C 43.5,366.5 43.5,351.5 43.5,336.5C 52.1667,336.5 60.8333,336.5 69.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfbfa7",
    d: "M 69.5,337.5 C 69.5,337.167 69.5,336.833 69.5,336.5C 70.5,336.5 71.5,336.5 72.5,336.5C 76.5,336.5 80.5,336.5 84.5,336.5C 84.8293,351.343 84.496,366.01 83.5,380.5C 83.5,366.167 83.5,351.833 83.5,337.5C 79.1667,337.5 74.8333,337.5 70.5,337.5C 70.1667,337.5 69.8333,337.5 69.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e98d31",
    d: "M 70.5,337.5 C 74.8333,337.5 79.1667,337.5 83.5,337.5C 83.5,351.833 83.5,366.167 83.5,380.5C 79.1667,380.5 74.8333,380.5 70.5,380.5C 71.1119,366.162 71.1119,351.828 70.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2acaf",
    d: "M 69.5,381.5 C 69.5,381.167 69.5,380.833 69.5,380.5C 69.8333,380.5 70.1667,380.5 70.5,380.5C 74.8333,380.5 79.1667,380.5 83.5,380.5C 79.7016,381.483 75.7016,381.817 71.5,381.5C 71.3772,418.672 70.7106,455.672 69.5,492.5C 69.9107,455.33 69.9107,418.33 69.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99969a",
    d: "M 67.5,381.5 C 67.8333,381.5 68.1667,381.5 68.5,381.5C 68.9383,383.126 69.2716,384.793 69.5,386.5C 68.9061,428.995 67.9061,471.328 66.5,513.5C 66.891,471.145 67.5576,428.812 68.5,386.5C 67.9537,384.865 67.6204,383.199 67.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#ef6d1d",
    d: "M 426.5,466.5 C 445.428,465.305 461.262,471.638 474,485.5C 485.911,503.641 486.245,521.975 475,540.5C 461.63,556.629 444.463,563.129 423.5,560C 394.973,554.12 381.473,536.62 383,507.5C 385.348,491.165 393.848,479.332 408.5,472C 414.435,469.523 420.435,467.69 426.5,466.5 Z M 429.5,488.5 C 449.021,489.486 457.855,499.819 456,519.5C 449.59,537.827 437.424,542.993 419.5,535C 408.786,524.852 406.62,513.018 413,499.5C 416.971,493.438 422.471,489.772 429.5,488.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#ef6e1d",
    d: "M 655.5,466.5 C 673.61,464.806 688.61,470.64 700.5,484C 695.302,489.533 689.802,494.7 684,499.5C 670.643,485.203 656.977,484.87 643,498.5C 635.979,511.464 637.479,523.297 647.5,534C 661.195,541.42 673.528,539.587 684.5,528.5C 689.517,533.352 694.684,538.018 700,542.5C 698.036,546.812 694.869,550.312 690.5,553C 672.02,562.621 653.353,562.954 634.5,554C 613.497,538.983 607.331,519.15 616,494.5C 624.371,478.282 637.537,468.948 655.5,466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#ef6e1e",
    d: "M 292.5,468.5 C 309.17,468.333 325.837,468.5 342.5,469C 366.089,472.353 376.589,485.853 374,509.5C 369.536,524.669 359.369,533.169 343.5,535C 335.507,535.5 327.507,535.666 319.5,535.5C 319.5,543.167 319.5,550.833 319.5,558.5C 310.5,558.5 301.5,558.5 292.5,558.5C 292.5,528.5 292.5,498.5 292.5,468.5 Z M 319.5,489.5 C 326.906,489.152 334.239,489.652 341.5,491C 345.851,493.365 348.184,497.032 348.5,502C 348.184,506.968 345.851,510.635 341.5,513C 334.254,514.391 326.921,514.891 319.5,514.5C 319.5,506.167 319.5,497.833 319.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#f06d1d",
    d: "M 495.5,468.5 C 504.167,468.5 512.833,468.5 521.5,468.5C 521.5,491.5 521.5,514.5 521.5,537.5C 535.504,537.333 549.504,537.5 563.5,538C 564.479,544.744 564.812,551.578 564.5,558.5C 541.5,558.5 518.5,558.5 495.5,558.5C 495.5,528.5 495.5,498.5 495.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#ef6e1d",
    d: "M 573.5,468.5 C 582.167,468.5 590.833,468.5 599.5,468.5C 599.5,498.5 599.5,528.5 599.5,558.5C 590.833,558.5 582.167,558.5 573.5,558.5C 573.5,528.5 573.5,498.5 573.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#ef6d1d",
    d: "M 699.5,468.5 C 708.506,468.334 717.506,468.5 726.5,469C 733.639,480.119 740.639,491.285 747.5,502.5C 754.861,491.622 761.861,480.455 768.5,469C 776.853,468.168 785.187,468.335 793.5,469.5C 782.585,488.332 771.418,506.999 760,525.5C 759.5,536.495 759.333,547.495 759.5,558.5C 750.833,558.5 742.167,558.5 733.5,558.5C 733.667,547.495 733.5,536.495 733,525.5C 721.306,506.774 710.139,487.774 699.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef7227",
    d: "M 1023.5,499.5 C 1023.5,501.833 1023.5,504.167 1023.5,506.5C 1014.37,515.802 1005.37,525.302 996.5,535C 992.167,535.667 987.833,535.667 983.5,535C 973.451,524.621 963.784,513.954 954.5,503C 963.754,491.742 973.754,481.075 984.5,471C 987.242,468.23 990.242,467.896 993.5,470C 1003.31,479.981 1013.31,489.814 1023.5,499.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d696c",
    d: "M 68.5,381.5 C 68.8333,381.5 69.1667,381.5 69.5,381.5C 69.9107,418.33 69.9107,455.33 69.5,492.5C 69.698,517.017 69.0313,541.35 67.5,565.5C 66.5033,548.341 66.17,531.008 66.5,513.5C 67.9061,471.328 68.9061,428.995 69.5,386.5C 69.2716,384.793 68.9383,383.126 68.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6f20",
    d: "M 1020.5,576.5 C 1021.14,594.628 1021.81,612.628 1022.5,630.5C 1022.83,666.24 1022.49,701.906 1021.5,737.5C 1008.65,738.744 995.651,738.744 982.5,737.5C 981.167,737.5 979.833,737.5 978.5,737.5C 978.5,683.5 978.5,629.5 978.5,575.5C 984.144,568.345 989.644,561.012 995,553.5C 995.739,552.426 996.739,551.759 998,551.5C 1000.62,553.112 1002.95,555.112 1005,557.5C 1010,563.998 1015.17,570.331 1020.5,576.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebcc0",
    d: "M 72.5,535.5 C 73.8197,538.428 74.4864,541.761 74.5,545.5C 74.0175,555.168 73.5175,564.834 73,574.5C 72.5001,561.504 72.3334,548.504 72.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7c7f",
    d: "M 52.5,570.5 C 50.0849,569.186 47.2515,568.519 44,568.5C 37.836,568.117 31.6694,567.783 25.5,567.5C 21.7614,567.514 18.428,568.18 15.5,569.5C 14.596,568.791 14.2627,567.791 14.5,566.5C 27.5048,566.682 40.5048,567.015 53.5,567.5C 53.7373,568.791 53.404,569.791 52.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d0d0e",
    d: "M 52.5,570.5 C 51.2271,572.713 50.2271,575.046 49.5,577.5C 47.5275,580.084 46.5275,583.084 46.5,586.5C 46.7678,588.099 46.4345,589.432 45.5,590.5C 43.4152,592.684 42.4152,595.351 42.5,598.5C 42.2785,601.067 41.6118,603.401 40.5,605.5C 38.7234,608.505 37.7234,611.838 37.5,615.5C 37.5,615.833 37.5,616.167 37.5,616.5C 35.9348,618.509 34.9348,620.843 34.5,623.5C 33.5041,623.586 32.6708,623.252 32,622.5C 27.519,608.572 23.3523,594.572 19.5,580.5C 19.405,578.214 18.7384,576.214 17.5,574.5C 16.4625,573.07 15.7959,571.403 15.5,569.5C 18.428,568.18 21.7614,567.514 25.5,567.5C 31.6694,567.783 37.836,568.117 44,568.5C 47.2515,568.519 50.0849,569.186 52.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939194",
    d: "M 17.5,574.5 C 18.7384,576.214 19.405,578.214 19.5,580.5C 17.9261,578.898 17.2594,576.898 17.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b797b",
    d: "M 49.5,577.5 C 49.0719,580.785 48.0719,583.785 46.5,586.5C 46.5275,583.084 47.5275,580.084 49.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d1d5",
    d: "M 73.5,582.5 C 74.525,582.897 74.6917,583.563 74,584.5C 73.5357,583.906 73.369,583.239 73.5,582.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d0d5",
    d: "M 73.5,587.5 C 74.525,587.897 74.6917,588.563 74,589.5C 73.5357,588.906 73.369,588.239 73.5,587.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a797b",
    d: "M 45.5,590.5 C 45.0198,593.443 44.0198,596.11 42.5,598.5C 42.4152,595.351 43.4152,592.684 45.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848286",
    d: "M 40.5,605.5 C 40.2766,609.162 39.2766,612.495 37.5,615.5C 37.7234,611.838 38.7234,608.505 40.5,605.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767174",
    d: "M 66.5,513.5 C 66.17,531.008 66.5033,548.341 67.5,565.5C 67.5,589.5 67.5,613.5 67.5,637.5C 66.8333,637.5 66.1667,637.5 65.5,637.5C 65.168,595.997 65.5014,554.663 66.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea884d",
    d: "M 1020.5,576.5 C 1021.91,576.973 1022.57,577.973 1022.5,579.5C 1022.5,596.5 1022.5,613.5 1022.5,630.5C 1021.81,612.628 1021.14,594.628 1020.5,576.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787678",
    d: "M 37.5,616.5 C 37.4484,619.346 36.4484,621.68 34.5,623.5C 34.9348,620.843 35.9348,618.509 37.5,616.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 245.5,718.5 C 206.828,717 168.162,715.833 129.5,715C 128.505,741.426 128.172,767.926 128.5,794.5C 85.6893,793.26 42.6893,791.927 -0.5,790.5C -0.5,739.5 -0.5,688.5 -0.5,637.5C 21.5,637.5 43.5,637.5 65.5,637.5C 66.1667,637.5 66.8333,637.5 67.5,637.5C 126.502,637.397 185.502,637.064 244.5,636.5C 244.21,663.855 244.544,691.188 245.5,718.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6c3ad",
    d: "M 708.5,659.5 C 707.791,660.404 706.791,660.737 705.5,660.5C 705.5,675.167 705.5,689.833 705.5,704.5C 705.5,705.167 705.5,705.833 705.5,706.5C 705.5,716.833 705.5,727.167 705.5,737.5C 704.549,738.919 704.216,740.585 704.5,742.5C 702.508,715.187 701.842,687.52 702.5,659.5C 704.5,659.5 706.5,659.5 708.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M 708.5,659.5 C 709.5,659.5 710.5,659.5 711.5,659.5C 733.327,660.597 755.327,661.263 777.5,661.5C 777.5,675.833 777.5,690.167 777.5,704.5C 753.5,704.5 729.5,704.5 705.5,704.5C 705.5,689.833 705.5,675.167 705.5,660.5C 706.791,660.737 707.791,660.404 708.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#deaf89",
    d: "M 711.5,659.5 C 733.859,658.844 755.859,659.511 777.5,661.5C 755.327,661.263 733.327,660.597 711.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e5f9",
    d: "M 1022.5,579.5 C 1022.83,579.5 1023.17,579.5 1023.5,579.5C 1023.5,632.167 1023.5,684.833 1023.5,737.5C 1022.83,737.5 1022.17,737.5 1021.5,737.5C 1022.49,701.906 1022.83,666.24 1022.5,630.5C 1022.5,613.5 1022.5,596.5 1022.5,579.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d56f27",
    d: "M 705.5,704.5 C 729.5,704.5 753.5,704.5 777.5,704.5C 777.5,705.167 777.5,705.833 777.5,706.5C 753.5,706.5 729.5,706.5 705.5,706.5C 705.5,705.833 705.5,705.167 705.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8874c",
    d: "M 978.5,575.5 C 978.5,629.5 978.5,683.5 978.5,737.5C 979.833,737.5 981.167,737.5 982.5,737.5C 981.081,738.451 979.415,738.784 977.5,738.5C 977.168,683.997 977.501,629.664 978.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M 705.5,706.5 C 729.5,706.5 753.5,706.5 777.5,706.5C 777.5,719.167 777.5,731.833 777.5,744.5C 775.833,744.5 774.167,744.5 772.5,744.5C 750.357,742.807 728.024,742.141 705.5,742.5C 705.5,740.833 705.5,739.167 705.5,737.5C 705.5,727.167 705.5,716.833 705.5,706.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e1e",
    d: "M 245.5,718.5 C 275.835,719.131 306.168,719.798 336.5,720.5C 342.645,721.49 348.978,721.823 355.5,721.5C 386.176,721.856 416.842,722.522 447.5,723.5C 447.5,750.5 447.5,777.5 447.5,804.5C 444.167,804.5 440.833,804.5 437.5,804.5C 334.696,801.839 232.029,799.006 129.5,796C 128.944,795.617 128.611,795.117 128.5,794.5C 128.172,767.926 128.505,741.426 129.5,715C 168.162,715.833 206.828,717 245.5,718.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e99667",
    d: "M 355.5,721.5 C 348.978,721.823 342.645,721.49 336.5,720.5C 342.891,719.687 349.224,720.02 355.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea8b4e",
    d: "M 705.5,737.5 C 705.5,739.167 705.5,740.833 705.5,742.5C 728.024,742.141 750.357,742.807 772.5,744.5C 768.167,744.5 763.833,744.5 759.5,744.5C 741.194,744.084 722.86,743.417 704.5,742.5C 704.216,740.585 704.549,738.919 705.5,737.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfcfd4",
    d: "M 759.5,745.5 C 758.833,746.167 758.833,746.167 759.5,745.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c7cd",
    d: "M 759.5,745.5 C 759.5,745.167 759.5,744.833 759.5,744.5C 763.833,744.5 768.167,744.5 772.5,744.5C 774.167,744.5 775.833,744.5 777.5,744.5C 777.5,745.5 777.5,746.5 777.5,747.5C 771.311,747.965 765.311,747.298 759.5,745.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e88e57",
    d: "M 447.5,723.5 C 448.498,750.662 448.831,777.995 448.5,805.5C 444.629,805.815 440.962,805.482 437.5,804.5C 440.833,804.5 444.167,804.5 447.5,804.5C 447.5,777.5 447.5,750.5 447.5,723.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020102",
    d: "M 655.5,788.5 C 658.167,788.5 660.833,788.5 663.5,788.5C 682.638,790.252 701.971,791.252 721.5,791.5C 737.495,792.024 753.495,792.357 769.5,792.5C 799.989,794.084 830.655,795.084 861.5,795.5C 880.647,796.99 899.98,797.657 919.5,797.5C 923.833,797.5 928.167,797.5 932.5,797.5C 949.305,799.132 966.305,799.799 983.5,799.5C 996.825,800.1 1010.16,800.433 1023.5,800.5C 1023.5,826.833 1023.5,853.167 1023.5,879.5C 899.167,879.5 774.833,879.5 650.5,879.5C 650.823,872.978 650.49,866.645 649.5,860.5C 649.5,836.5 649.5,812.5 649.5,788.5C 651.5,788.5 653.5,788.5 655.5,788.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#605f61",
    d: "M 663.5,788.5 C 682.831,789.211 702.165,789.878 721.5,790.5C 721.5,790.833 721.5,791.167 721.5,791.5C 701.971,791.252 682.638,790.252 663.5,788.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838185",
    d: "M 721.5,791.5 C 721.5,791.167 721.5,790.833 721.5,790.5C 737.678,790.654 753.678,791.321 769.5,792.5C 753.495,792.357 737.495,792.024 721.5,791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656466",
    d: "M 769.5,792.5 C 801.348,792.78 833.015,793.78 864.5,795.5C 863.5,795.5 862.5,795.5 861.5,795.5C 830.655,795.084 799.989,794.084 769.5,792.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666466",
    d: "M 861.5,795.5 C 862.5,795.5 863.5,795.5 864.5,795.5C 882.856,795.525 901.19,796.191 919.5,797.5C 899.98,797.657 880.647,796.99 861.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6e",
    d: "M 932.5,797.5 C 949.673,797.775 966.673,798.442 983.5,799.5C 966.305,799.799 949.305,799.132 932.5,797.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaa7ab",
    d: "M 655.5,788.5 C 653.5,788.5 651.5,788.5 649.5,788.5C 649.5,812.5 649.5,836.5 649.5,860.5C 649.5,860.833 649.5,861.167 649.5,861.5C 648.502,837.006 648.169,812.339 648.5,787.5C 651.059,787.198 653.393,787.532 655.5,788.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010102",
    d: "M 74.5,847.5 C 77.1667,847.5 79.8333,847.5 82.5,847.5C 82.5,858.167 82.5,868.833 82.5,879.5C 66.1667,879.5 49.8333,879.5 33.5,879.5C 33.5,868.5 33.5,857.5 33.5,846.5C 47.171,846.689 60.8377,847.022 74.5,847.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5b5d",
    d: "M 74.5,846.5 C 74.5,846.833 74.5,847.167 74.5,847.5C 60.8377,847.022 47.171,846.689 33.5,846.5C 33.5,857.5 33.5,868.5 33.5,879.5C 33.1667,879.5 32.8333,879.5 32.5,879.5C 32.5,868.167 32.5,856.833 32.5,845.5C 46.5062,845.62 60.5062,845.954 74.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99969b",
    d: "M 74.5,847.5 C 74.5,847.167 74.5,846.833 74.5,846.5C 77.5,846.5 80.5,846.5 83.5,846.5C 83.5,857.5 83.5,868.5 83.5,879.5C 83.1667,879.5 82.8333,879.5 82.5,879.5C 82.5,868.833 82.5,858.167 82.5,847.5C 79.8333,847.5 77.1667,847.5 74.5,847.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535153",
    d: "M 649.5,860.5 C 650.49,866.645 650.823,872.978 650.5,879.5C 650.167,879.5 649.833,879.5 649.5,879.5C 648.287,873.468 648.287,867.468 649.5,861.5C 649.5,861.167 649.5,860.833 649.5,860.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.86f9e20abb319c234098627e034b1172.svg";
export { ForwardRef as ReactComponent };